module.exports = __webpack_public_path__ + "static/img/8ways_tc.5918f36b.png";